import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Проверка пользователя в Telegram
export const checkTelegramUser = async (username) => {
    try {
      const response = await axios.post(`${API_URL}/user`, null, {
        params: { username },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || "Ошибка при проверке пользователя";
    }
  };  

// Генерация VPN-конфигурации
export const generateTrialConfig = async (telegramId) => {
  try {
    const response = await axios.post(`${API_URL}/config/trial`, null, {
      params: {
        telegram_id: telegramId,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.detail || "Ошибка при генерации пробной конфигурации";
  }
};
